import * as React from 'react';
import PlayerSessions from '@screens/players/player.details.tabs/sessions/player.sessions';
import PlayerSessionsDetails from '@screens/players/player.details.tabs/sessions/player.sessions.details';
import { PlayerSessionDataProps } from '@screens/players/player.details.tabs/sessions/player.session.data.props';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useParams } from 'react-router-dom';

const PlayerSessionsTab = ({ player }: PlayerDataProps) => {
  const { sessionId, gameSessionId } = useParams<PlayerSessionDataProps>();

  return (
    <>
      <PlayerSessions player={player} />
      {sessionId && <PlayerSessionsDetails sessionId={sessionId} gameSessionId={gameSessionId} />}
    </>
  );
};
export default PlayerSessionsTab;
